import {Button, Table, TableBody, TableCell, TableRow} from "@mui/material";
import {humanByteSize} from "../../utility/humanReadable";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {ITableFingerprint} from "../../utility/firebaseTools";

const useStyles = makeStyles(theme => ({
    cell: {
        color: theme.palette.warning.main
    }
}));

interface IVersionDifferences{
    onClose: () => void
    previous?: ITableFingerprint
    tableKey: string
    table: ITableFingerprint
}
export default function VersionDifferences({onClose, previous, tableKey, table}: IVersionDifferences) {
    const classes = useStyles();
    return (
        <TableRow>
            <TableCell colSpan={3}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell classes={{root: classes.cell}}>
                                <Button onClick={onClose}>{tableKey}</Button>
                            </TableCell>
                            <TableCell classes={{root: classes.cell}}>
                                {humanByteSize(table.size)}
                            </TableCell>
                            <TableCell classes={{root: classes.cell}}>
                                {table.hash}
                            </TableCell>
                        </TableRow>
                        {Object.keys(table.records || {}).map(recordKey => {
                            const record = table.records[recordKey];
                            const previousRecord = previous?.records && previous?.records[recordKey];

                            if (previousRecord?.hash === record.hash) {
                                return null;
                            } else {
                                return (
                                    <TableRow key={tableKey}>
                                        <TableCell classes={{root: classes.cell}}>{recordKey}</TableCell>
                                        <TableCell classes={{root: classes.cell}}>{humanByteSize(record.size)}</TableCell>
                                        <TableCell classes={{root: classes.cell}}>{record.hash}</TableCell>
                                    </TableRow>
                                );
                            }
                        })
                        }
                    </TableBody>
                </Table>
            </TableCell>
        </TableRow>
    )
}